var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.12793 8.86032C0.12793 4.31021 3.85074 0.587402 8.40085 0.587402C12.951 0.587402 16.6738 4.31021 16.6738 8.86032C16.6738 13.4104 12.951 17.1332 8.40085 17.1332C3.85074 17.1332 0.12793 13.4104 0.12793 8.86032ZM5.97068 7.51597H4.05757V13.3587H5.97068V7.51597ZM6.12579 5.70627C6.12579 5.13751 5.71215 4.72386 5.03997 4.72386C4.3678 4.72386 3.90245 5.13751 3.90245 5.70627C3.90245 6.27503 4.31609 6.74038 4.98827 6.74038C5.66044 6.74038 6.12579 6.27503 6.12579 5.70627ZM12.951 9.99784C12.951 8.18814 11.9685 7.36085 10.7276 7.36085C9.69349 7.36085 9.22814 7.92962 8.96961 8.34326V7.51597H7.0565C7.0565 8.08473 7.0565 13.3587 7.0565 13.3587H8.96961V10.1013C8.96961 9.94614 8.96961 9.73932 9.02132 9.63591C9.17643 9.27396 9.48667 8.91202 10.0037 8.91202C10.6759 8.91202 10.9861 9.42908 10.9861 10.2564V13.3587H12.8992C12.951 13.3587 12.951 9.99784 12.951 9.99784Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/linkedIn_logo.7ce0416e49f245eaafc4b2df9fcdb1bf.svg";
export { ForwardRef as ReactComponent };